import { InterviewStatus } from '../interviewStatus';


export class InterviewStatusSerializer {
    fromJson(json: any): any {
        const data = new InterviewStatus();
        data.value = json.id;
        data.label = json.name;
        data.id = json.id;
        data.name= json.name;
        return json;
    }

    toJson(data: InterviewStatus): any {
        return {
            id: data.id,
            name: data.name
        };
    }
}